<div class="wrapper-page admin-single-blog">
  <div class="wrapper-header-page">
    <div class="overlay-illustration-header"></div>
  </div>
  <div class="wrapper-content-page">
    <div class="wrapper-header-page-content">
      <div class="wrapper-back-btn">
        <div class="back-btn" [routerLink]="[PAGES_AND_PATHS.adminBlogs.pagePath]">
          <i class="fa-solid fa-chevron-left"></i>
        </div>
        <span class="header-text">{{editBlogForm.controls.is_saved.value ? 'Kreiraj blog' : 'Kreiraj blog'}}</span>
      </div>
    </div>
    <div class="admin-content-single-blog">
      <form [formGroup]="editBlogForm" (ngSubmit)="submitEditBlogForm()">
        <div class="grid">
          <div class="grid__m-6">
            <gr-dropdown-reactive-form
              [items]="blogCategories"
              [propIdentifier]="'name'"
              [dropdownLabel]="'Izaberi kategoriju za blog'"
              [placeholder]="'Izaberite kategoriju'"
              [formControl]="editBlogForm.controls.category | formControl"
              [formTriedToSubmit]="formTriedToSubmit"
            ></gr-dropdown-reactive-form>
          </div>
          <div class="grid__m-6">
            <div class="wrapper-input">
              <span class="label-input">Ime i prezime autora bloga</span>
              <div class="zc-input">
                <input type="text" formControlName="author_name">
              </div>
              <span
                class="error-message">{{ editBlogForm.controls.author_name | formControlErrorMessages: null : formTriedToSubmit }}</span>
            </div>
          </div>
          <div class="grid__m-12">
            <div class="xs-mb-20">
              <div class="admin-title-element">
                <span>Istaknite blog</span>
              </div>
              <div class="wrapper-custom-radiobutton xs-mt-10">
                <label>
                  <input type="checkbox" formControlName="is_featured" [value]="true">
                  <div class="custom-radiobutton">
                    <div class="circle-radio">
                      <div class="circle-center"></div>
                    </div>
                    <span>Istaknut</span>
                  </div>
                </label>
              </div>
            </div>
          </div>
          <div class="grid__m-12">
            <div class="xs-mb-20">
              <div class="label-banner xs-mb-10">
                <span>Dodajte naslovu fotografiju za vaš blog</span>
              </div>
              <div class="wrapper-custom-gallery banners">
                <div *ngIf="!coverImageUrl" class="header-custom-gallery">
                  <div class="wrapper-btn-gallery">
                    <div class="file-input">
                      <label *ngIf="!isUploading" class="file-input__label2">
                        <span>Dodaj Sliku</span>
                        <input #fileInput class="file-input__input" type="file" accept=".jpg,.jpeg,.png,.svg" (change)="onFileChange($event)"/>
                      </label>
                      <div *ngIf="isUploading" class="file-input__label2">
                        <div class="wrapper-progressbar">
                          <div class="progressbar-content" [ngStyle]="{'width': totalProgress + '%'}"></div>
                        </div>
                      </div>
                    </div>

                  </div>
<!--                  <span class="error-message">{{ editBlogForm.controls.cover_image | formControlErrorMessages: null : formTriedToSubmit }}</span>-->
                </div>
                <div *ngIf="coverImageUrl" class="content-custom-gallery-banner admin-blog-cover-photo">
                  <div class="wrapper-gallery-image-banner">
                    <img [src]="coverImageUrl" alt="banner-image">
                    <div class="overlay-delete" (click)="removeFile()">
                      <i class="fa-solid fa-xmark"></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="grid__m-6">
            <div class="wrapper-input">
              <span class="label-input">Unesite naslov za blog</span>
              <div class="zc-input">
                <input type="text" formControlName="title">
              </div>
              <span
                class="error-message">{{ editBlogForm.controls.title | formControlErrorMessages: null : formTriedToSubmit }}</span>
            </div>
          </div>
          <div class="grid__m-12">
            <div class="admin-title-element">
              <span>Unesite uvodni tekst bloga</span>
            </div>
            <div class="wrapper-quill-editor">
              <quill-editor
                [modules]="modules"
                [formControl]="editBlogForm.controls.intro_text | formControl">
              </quill-editor>
              <span class="error-message">{{editBlogForm.controls.intro_text | formControlErrorMessages: null : formTriedToSubmit}}</span>
            </div>
          </div>
          <div class="grid__m-12" *ngFor="let section of editBlogForm.controls.sections.value; index as sectionIndex">
            <div *ngIf="section.type === BlogSectionType.image"  >
              <div class="xs-mb-20">
                <div class="label-banner xs-mb-10">
                  <span>Dodajte naslovu fotografiju za vaš blog</span>
                </div>
                <div class="wrapper-custom-gallery banners">
                  <div *ngIf="!section.fullPath" class="header-custom-gallery">
                    <div class="wrapper-btn-gallery">
                      <div class="file-input">
                        <label *ngIf="!isUploading" class="file-input__label2">
                          <span>Dodaj Sliku</span>
                          <input #fileInput class="file-input__input" type="file" accept=".jpg,.jpeg,.png,.svg" (change)="onFileChange($event, sectionIndex)"/>
                        </label>
                        <div *ngIf="isUploading" class="file-input__label2">
                          <div class="wrapper-progressbar">
                            <div class="progressbar-content" [ngStyle]="{'width': totalProgress + '%'}"></div>
                          </div>
                        </div>
                      </div>

                    </div>
                    <!--                  <span class="error-message">{{ editBlogForm.controls.cover_image | formControlErrorMessages: null : formTriedToSubmit }}</span>-->
                  </div>
                  <div *ngIf="section.fullPath" class="content-custom-gallery-banner admin-blog-cover-photo">
                    <div class="wrapper-gallery-image-banner">
                      <img [src]="section.fullPath" alt="banner-image">
                      <div class="overlay-delete" (click)="removeFile()">
                        <i class="fa-solid fa-xmark"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div *ngIf="section.type === BlogSectionType.text" class="wrapper-quill-editor">
              <quill-editor
                [modules]="modules"
                [formControl]="editBlogForm.controls.intro_text | formControl">
              </quill-editor>
              <span class="error-message">{{editBlogForm.controls.intro_text | formControlErrorMessages: null : formTriedToSubmit}}</span>
            </div>
          </div>
          <div class="grid__m-12">
            <button (click)="addNewSection(BlogSectionType.heading)" class="zc-btn zc-btn--primary xs-mr-20"><span>Dodaj naslov</span>
            </button>
            <button (click)="addNewSection(BlogSectionType.text)" class="zc-btn zc-btn--primary xs-mr-20"><span>Dodaj text</span>
            </button>
            <button (click)="addNewSection(BlogSectionType.image)" class="zc-btn zc-btn--primary xs-mr-20"><span>Dodaj sliku</span>
            </button>
            <button (click)="addNewSection(BlogSectionType.video)" class="zc-btn zc-btn--primary xs-mr-20"><span>Dodaj video</span>
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>

